import React from 'react'

const SvgDecreaseFont = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.112 15H4.913c-.32 1.35-.592 2.509-.734 3.116-.068.289-.43 1.05-1.388.852-.639-.132-.89-.554-.756-1.266l2.89-10.538C5.259 5.721 5.955 5 7.013 5c1.059 0 1.755.721 2.088 2.164l2.879 10.541c.098.743-.167 1.164-.796 1.263-.943.147-1.256-.563-1.325-.852-.247-1.04-.496-2.078-.747-3.116zm-.488-2c-.727-2.962-1.5-6-1.61-6-.137 0-.904 3.038-1.621 6h3.231zM15 11h6c.667.002 1 .336 1 1.002 0 .665-.333.998-1 .998h-6c-.667 0-1-.333-1-1s.333-1 1-1z'
    />
  </svg>
)

export default SvgDecreaseFont
